

























import {
  defineComponent,
  onMounted,
  reactive,
} from '@vue/composition-api';

import SponsorItem from '@/components/Config/SponsorItem.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import {
  getSponsors,
  createSponsor,
  updateSponsor,
  deleteSponsors,
} from '@/api/index';

const Sponsor = defineComponent({
  components: {
    SponsorItem,
    CommonModalWithPreset,
  },
  setup() {
    const sponsors: {
      id: number; name: string; url: string; logo: string | null;
    }[] = reactive([{
      id: -1, name: '', url: '', logo: '',
    }]);
    //   id: -1, name: '', url: '', logo: '',
    // }]);

    function addSponsor() {
      sponsors.push({
        id: -1, name: '', url: '', logo: '',
      });
    }

    async function getData() {
      const _sponsors = await getSponsors();
      if (_sponsors !== null) {
        sponsors.splice(0);
        _sponsors.forEach((spon: any) => {
          sponsors.push(spon);
        });
      }
    }

    async function submitEditForm(index: number) {
      if (sponsors[index].id === -1) {
        await createSponsor(sponsors[index]);
        await getData();
      } else updateSponsor(sponsors[index].id, sponsors[index]);
    }

    async function deleteSponsor(index: number) {
      if (sponsors[index].id > -1) {
        await deleteSponsors([sponsors[index].id]);
        await getData();
      } else sponsors.splice(index, 1);
    }

    onMounted(async () => {
      await getData();
    });

    return {
      sponsors,

      getData,
      addSponsor,
      submitEditForm,
      deleteSponsor,
    };
  },
});

export default Sponsor;
